/**
 * Plan status utilities, shared between the React app and Cloudflare Workers.
 *
 * The 14-day trial was retired with PK-235: non-subscribed accounts are on
 * the permanent free tier, so the only states are subscribed, free, and
 * unknown. The file keeps its historical name; trial_ends_at remains on
 * legacy rows but no longer drives anything.
 */

// "unknown" covers the case where account data couldn't be loaded (network
// failure, expired session in a stale tab) — distinct from a known free
// account so callers don't misreport a fetch failure as billing state.
export type TrialStatus = "free" | "subscribed" | "unknown";

export interface UserTrialInfo {
  subscribed?: boolean;
  trial_ends_at?: string | null;
}

export function getTrialStatus(user: UserTrialInfo): TrialStatus {
  return user.subscribed ? "subscribed" : "free";
}

export function isSubscribed(user: UserTrialInfo): boolean {
  return getTrialStatus(user) === "subscribed";
}
